module.exports = __webpack_public_path__ + "img/bg27.e58a09b0.jpg";